module.exports = __webpack_public_path__ + "img/jogos.dab34af5.gif";